{
  "$id": "module://display-configuration",
  "$schema": "wealthlane://schemas/domain",
  "title": "Display Configuration",
  "description": "Company-wide display settings (decimal precision for amounts and percentages, HTF-1482)",
  "type": "object",
  "properties": {
    "decimalPrecision": {
      "type": "string",
      "title": "Decimal Precision",
      "widget": "radio",
      "options": [
        { "label": "4 decimal places", "value": "4", "description": "Displays values like $10.0000 and 12.5000%." },
        { "label": "2 decimal places", "value": "2", "description": "Displays values like $10.00 and 12.50%." }
      ],
      "adapterProps": {
        "layout": "vertical",
        "hint": "Choose how many decimal places to show for amounts and percentages across the Admin and Participant Portals."
      }
    }
  }
}
